export const RESOURCE_TYPE_JIRA_HOME = 'JIRA_HOME';

// For You Project Recommendation Experiment - recommended_projects_for_you_page
export const RESOURCE_TYPE_JIRA_HOME_PROJECT_REC_EXPERIMENT = 'JIRA_HOME_PROJECT_REC_EXPERIMENT';
